import React, { useContext, useEffect, useState } from "react";
import { CurrencyDto } from "../../../../dtos/catalogs/currency/CurrencyDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import CurrencyDetailSkeleton from "./CurrencyDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import CurrencyDetailMain from "./CurrencyDetailMain";

interface IProps {
  model: CurrencyDto | null;
  modelUpdatedEvent: (newModel: CurrencyDto) => void;
}

interface CurrencyModel {
  id: string;
  name: string;
  symbolCode: string;
  currencyCode: string;
  createdDate: Date;
}

export const CurrencyDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<CurrencyModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("symbolCode", model.symbolCode);
      setValue("currencyCode", model.currencyCode);
      setValue("createdDate", model.createdDate);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: CurrencyModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: CurrencyDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <CurrencyDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <CurrencyDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
